module.exports = __webpack_public_path__ + "media/images/icons/flags/AW-f868c9ddbc6f5f0ad5f20f2e5743e4a1.svg";